import styled, { css } from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledAudioContainerProps {
  theme: any;
}

export const StyledAudioContainer = styled.div<StyledAudioContainerProps>`
  margin: ${pxToRem(20)};
  display: flex;
  align-items: center;
  flex-direction: column;

  audio {
    width: 100%;

    &::-webkit-media-controls-panel {
      ${({ theme }) => theme.audio_background_color && `background-color: ${theme.audio_background_color}`};
      ${({ theme }) =>
        theme.audio_background &&
        css`
          background: ${theme.audio_background};
        `};
    }
  }

  legend {
    margin: ${pxToRem(10)} 0;
  }
`
